export default function MXShoppingBag({ className }: { className?: string }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25.1748 26.8339L23.6399 9.9502H21.0818L19.5469 26.8339H25.1748Z"
        fill="#C41719"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8944 9.83724L25.4293 26.721C25.4315 26.7561 25.4265 26.7914 25.4148 26.8247C25.4031 26.8579 25.3848 26.8884 25.361 26.9145C25.3372 26.9405 25.3085 26.9615 25.2764 26.9762C25.2444 26.9909 25.2097 26.999 25.1745 27H6.75585C6.72029 27 6.68513 26.9926 6.65259 26.9783C6.62006 26.9639 6.59088 26.9429 6.5669 26.9167C6.54293 26.8904 6.52469 26.8595 6.51335 26.8258C6.50202 26.7921 6.49783 26.7564 6.50106 26.721L8.03594 9.83724C8.04174 9.77367 8.07109 9.71457 8.11823 9.67153C8.16537 9.6285 8.2269 9.60464 8.29073 9.60465H10.8421L10.9456 8.46597C10.9977 7.87344 11.1883 7.30143 11.5019 6.796C11.8155 6.29057 12.2434 5.86584 12.7511 5.55602C13.2589 5.2462 13.8323 5.05993 14.4252 5.01224C15.0181 4.96454 15.6139 5.05673 16.1647 5.2814C16.7708 5.0348 17.4301 4.94818 18.0794 5.02988C18.7286 5.11157 19.346 5.35882 19.8721 5.74789C20.3982 6.13696 20.8155 6.65477 21.0838 7.2516C21.3521 7.84842 21.4625 8.50421 21.4043 9.15598L21.3636 9.60465H23.6396C23.7034 9.60462 23.765 9.62847 23.8121 9.67151C23.8593 9.71454 23.8886 9.77366 23.8944 9.83724ZM18.9404 5.79216C18.5209 5.60716 18.0675 5.51162 17.609 5.51163C17.3373 5.51249 17.0667 5.54652 16.8032 5.61296C17.3909 5.98607 17.8639 6.51455 18.1698 7.13988C18.4757 7.76521 18.6025 8.463 18.5363 9.15598L18.4957 9.60465H20.8499L20.8947 9.10975C20.9362 8.65318 20.8822 8.19295 20.7359 7.75844C20.5897 7.32393 20.3545 6.92466 20.0453 6.58611C19.7362 6.24757 19.3599 5.97717 18.9404 5.79216ZM14.2239 9.60465H17.982L18.0268 9.10975C18.0894 8.43993 17.9446 7.76705 17.612 7.18229C17.2794 6.59753 16.775 6.12918 16.1672 5.84071C15.6546 6.08788 15.215 6.46413 14.8917 6.93252C14.5684 7.40091 14.3725 7.94533 14.3232 8.51233L14.2239 9.60465ZM11.8754 7.16559C11.6393 7.57877 11.4959 8.03834 11.4552 8.51245L11.3559 9.60465H13.71L13.8135 8.46597C13.8638 7.89096 14.0446 7.33499 14.3422 6.84042C14.6398 6.34585 15.0464 5.92571 15.5309 5.61201C15.0696 5.49519 14.5884 5.48008 14.1207 5.56773C13.653 5.65537 13.2099 5.84367 12.8222 6.11958C12.4345 6.39548 12.1114 6.7524 11.8754 7.16559ZM20.8013 10.1163H8.52437L7.03609 26.4884H19.3129L20.8013 10.1163ZM21.3152 10.1163L19.8721 26.4884H24.9166L23.406 10.1163H21.3152Z"
        fill="black"
      />
      <path
        d="M11.5661 16.1836L10.6953 19.2258L11.4372 19.2286L12.2852 16.1836H11.5661Z"
        fill="black"
      />
      <path
        d="M13.4893 16.1865L12.6471 17.1117L12.3549 16.1836L12.0312 17.2721L12.2776 18.3578L13.1771 17.275L13.4893 16.1865Z"
        fill="black"
      />
      <path
        d="M13.4177 19.2344L14.2828 16.1894L13.538 16.1865L12.6758 19.2316L13.4177 19.2344Z"
        fill="black"
      />
      <path
        d="M15.0701 19.2369L15.9122 19.2397L15.5341 17.6213L16.7143 16.1947H16.0068L15.3737 16.971L15.1961 16.1918L14.3596 16.189L14.7148 17.7129L12.4375 20.4171L13.1565 20.42L14.8695 18.4004L15.0701 19.2369Z"
        fill="black"
      />
      <path
        d="M14.2299 19.4092H14.1039L13.9062 20.111H14.3617L14.3875 20.0079L14.0609 20.0021L14.2299 19.4092Z"
        fill="black"
      />
      <path
        d="M14.793 19.9473L14.7357 19.996H14.5753L14.5409 19.953L14.6469 19.5692L14.7041 19.5262H14.8588L14.8989 19.5692L14.793 19.9473ZM14.9505 19.4116H14.6841L14.538 19.5176L14.4062 20.0017L14.495 20.1192H14.75L14.9018 19.9989L15.0364 19.5233L14.9505 19.4116Z"
        fill="black"
      />
      <path
        d="M15.3385 19.8528L15.3128 19.9588L15.2583 19.9989H15.1122L15.0779 19.9444L15.1838 19.5806L15.244 19.5291H15.393L15.4187 19.5778L15.3987 19.6637H15.5247L15.562 19.5147L15.4789 19.4116H15.2268L15.0693 19.5319L14.9375 19.9903L15.0349 20.1192H15.2784L15.4273 20.0017L15.4646 19.8556L15.3385 19.8528Z"
        fill="black"
      />
      <path
        d="M16.15 19.4146H16.0154L15.6945 19.6953L15.7719 19.4146H15.6458L15.4453 20.1192L15.5771 20.1221L15.6487 19.8757L15.7662 19.7726L15.832 20.1221H15.9581L15.8693 19.6724L16.15 19.4146Z"
        fill="black"
      />
      <path
        d="M16.2099 19.8013H16.4448L16.4677 19.7039H16.2328L16.2786 19.532H16.6195L16.651 19.4174L16.1956 19.4146L15.9922 20.1221H16.4534L16.4849 20.0047H16.1526L16.2099 19.8013Z"
        fill="black"
      />
      <path
        d="M16.7378 19.7208L16.7893 19.5374H16.9727L17.0013 19.5718L16.9784 19.6807L16.9268 19.7265L16.7378 19.7208ZM17.0901 19.7208L17.1417 19.5202L17.0672 19.4229H16.7034L16.5 20.1304H16.6261L16.7063 19.8439H16.7922L16.838 20.1304H16.9669L16.9154 19.8439H16.9498L17.0901 19.7208Z"
        fill="black"
      />
    </svg>
  );
}
